export const PRIORITY = {
  all: ['high', 'medium', 'low'],
};
